import { updateQuery } from '../../services/Utils'
import { gettext } from '../../services/TranslateHandler'
import CONSTANTS from '../../constants'

export default {
  data () {
    return {
      socialErrorData: {}
    }
  },
  methods: {
    gettext: gettext,
    toSocial (link, params = {}) {
      location.replace(link + updateQuery('', params, true))
    },
    socialHasError () {
      return this.$route.query.error_code
    },
    socialErrorHandler (error) {
      if (parseInt(error.error_code) in this.errorsText) {
        return {
          ...error,
          ...{
            message: this.errorsText[error.error_code]
          }
        }
      } else if (parseInt(error.error_code)) {
        return {
          ...error,
          ...{
            message: this.errorsText['default']
          }
        }
      }
      return {}
    },
    async socialNewUser ({profileType = '', profileCountry = '', ptoken, u, agree}) {
      const data = new FormData()
      data.append('profile_type', profileType)
      data.append('profile_country', profileCountry)
      data.append('ptoken', ptoken)
      data.append('agree', agree)
      let settings = {
        method: 'POST',
        url: u,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        data: data
      }
      let res = await this.$http(settings)
      location.replace(res.data.redirect_url)
    }
  },
  computed: {
    socialError () {
      return this.socialErrorData
    },
    errorsText () {
      return {
        [CONSTANTS.SOCIAL_LOGIN_ERROR_EMAIL]: gettext('Sorry, an error occurred! It looks like your account is not giving an email address. Please check your profile settings.'),
        [CONSTANTS.SOCIAL_LOGIN_ERROR_TYPE]: gettext('Sorry, an error occurred! Unsupported profile type.'),
        [CONSTANTS.SOCIAL_LOGIN_ERROR_NOT_ACTIVE]: gettext('Sorry, an error occurred! Your profile is still not active.'),
        [CONSTANTS.SOCIAL_LOGIN_ERROR_NOT_VERIFIED]: gettext('Sorry, an error occurred! Your profile is still not verified.'),
        default: gettext('An unexpected error!')
      }
    }
  },
  created () {
    this.socialErrorData = this.socialErrorHandler(this.$route.query)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SocialMixin/SocialMixin.js